<div class="signature-pad-container">

  <canvas #canvas></canvas>

  <div class="signature-pad-buttons">

    <button
      type="button"
      (click)="clearCanvas()">

      Clear

    </button>

    <button
      type="button"
      (click)="emitSignature()">

      Use This Signature

    </button>

  </div>

</div>